var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { NgModule, Optional } from '@angular/core';
import { UserTrackingService, ScreenTrackingService } from './analytics.service';
import { AngularFireAnalytics } from './analytics';
var AngularFireAnalyticsModule = (function () {
    function AngularFireAnalyticsModule(analytics, screenTracking, userTracking) {
        analytics.app;
    }
    AngularFireAnalyticsModule = __decorate([
        NgModule({
            providers: [AngularFireAnalytics]
        }),
        __param(1, Optional()),
        __param(2, Optional()),
        __metadata("design:paramtypes", [AngularFireAnalytics,
            ScreenTrackingService,
            UserTrackingService])
    ], AngularFireAnalyticsModule);
    return AngularFireAnalyticsModule;
}());
export { AngularFireAnalyticsModule };
//# sourceMappingURL=analytics.module.js.map